import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { GET, newFetch, POST, PUT } from '../../../../../helpers/fetch';

const SEV = ({ history }) => {
  const [SEVs, setSEVs] = useState([]);
  const [oldSEVs, setOldSEVs] = useState([]);
  const [newSEVs, setNewSEVs] = useState([]);

  useEffect(() => {
    const fetchSEVs = async () => {
      let api_path = '/tt/severity';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setSEVs(response.data);
        setOldSEVs(JSON.parse(JSON.stringify(response.data)));
      }
    };

    fetchSEVs();
  }, []);

  const addNewSEV = () => {
    var newID = '';

    if (newSEVs.length > 0) {
      const lastNewSEV = [...newSEVs].pop();
      newID = lastNewSEV.id + 1;
    } else {
      const lastOldSEV = [...oldSEVs].pop();
      newID = lastOldSEV ? lastOldSEV.id + 1 : 1;
    }

    setNewSEVs([
      ...newSEVs,
      {
        id: newID,
        name: `Level ${newID}`,
        duration: '',
      },
    ]);
  };

  // const updateNewSEVName = (index, e) => {
  //     let clone = [...newSEVs]
  //     clone[index].name = e.target.value
  //     setNewSEVs(clone)
  // }

  const updateNewSEVDuration = (index, e) => {
    let clone = [...newSEVs];
    clone[index].duration = e.target.value;
    setNewSEVs(clone);
  };

  const deleteNewSEV = (index) => {
    let filteredSEVs = [...newSEVs].filter((sev, i) => i !== index);
    setNewSEVs(filteredSEVs);
  };

  // const updateOldSEVName = (index, e) => {
  //     let clone = [...oldSEVs]
  //     clone[index].name = e.target.value
  //     setOldSEVs(clone)
  // }

  const updateOldSEVDuration = (index, e) => {
    let clone = [...oldSEVs];
    clone[index].duration = e.target.value;
    setOldSEVs(clone);
  };

  // const deleteOldSEV = async id => {
  //     if (await AlertService.confirm("", 'Are you sure you want to delete this severity?')) {
  //         let api_path = `/tt/severity/${id}`
  //         let response = await newFetch(DELETE, api_path)

  //         ToastUtil.success(response.message)
  //         response.success && window.location.reload()
  //     }
  // }

  const discardSEVHandler = () => {
    setOldSEVs(SEVs);
    setNewSEVs([]);
  };

  const submitSEVHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm('', 'Are you sure you want to update SEVs?')
    ) {
      let api_path = `/tt/severity`;

      // // update old severity
      if (oldSEVs.length > 0) {
        let update_data = {
          severities: oldSEVs.map((sev) => ({
            id: sev.id,
            name: sev.name,
            duration: sev.duration,
          })),
        };
        let update_response = await newFetch(PUT, api_path, update_data);

        ToastUtil.success(update_response.message);

        update_response.success &&
          newSEVs.length <= 0 &&
          window.location.reload();
      }

      // // create new severity
      if (newSEVs.length > 0) {
        let create_data = { severities: newSEVs };
        let create_response = await newFetch(POST, api_path, create_data);

        ToastUtil.success(create_response.message);
        create_response.success && window.location.reload();
      }
    }
  };

  return (
    <form onSubmit={(e) => submitSEVHandler(e)} className="d-flex flex-column">
      <div className="p-4 d-flex flex-column">
        <h5 className="mb-4 pb-2">Duration</h5>
        <div className="row border-bottom mb-2 pb-2 mx-1">
          <div className="col-8 p-0 fw-bold">SEV Levels</div>
          <div className="col-3 p-0 text-end fw-bold">Duration (hrs)</div>
          <div className="col-1"></div>
        </div>
        {oldSEVs.map((sev, index) => (
          <div key={index} className="row py-2">
            {/* <div className="col-9"><input type="text" className="form-control" value={sev.name} onChange={e => updateOldSEVName(index, e)} /></div> */}
            <div className="col-8">{sev.name}</div>
            <div className="col-3">
              <input
                type="number"
                min="0"
                className="form-control text-center"
                value={sev.duration}
                onChange={(e) => updateOldSEVDuration(index, e)}
              />
            </div>
            {/* <div className="col-1 text-center" style={{ cursor: 'pointer' }} onClick={() => deleteOldSEV(sev.id)}><i className="fas fa-times text-danger pt-2"></i></div> */}
            <div className="col-1 text-center"></div>
          </div>
        ))}
        {newSEVs.map((sev, index) => (
          <div key={index} className="row py-2">
            {/* <div className="col-9"><input type="text" className="form-control" value={sev.name} onChange={e => updateNewSEVName(index, e)} /></div> */}
            <div className="col-8">{sev.name}</div>
            <div className="col-3">
              <input
                type="number"
                min="0"
                className="form-control text-center adjust-fs"
                value={sev.duration}
                onChange={(e) => updateNewSEVDuration(index, e)}
              />
            </div>
            <div
              className="col-1 text-center"
              style={{ cursor: 'pointer' }}
              onClick={() => deleteNewSEV(index)}
            >
              <i className="fas fa-trash pt-2"></i>
            </div>
          </div>
        ))}

        <button
          type="button"
          className="btn btn-block btn-outline-brand text-start mt-2 p-3 adjust-fs adjust-shadow"
          onClick={() => addNewSEV()}
        >
          <i className="fas fa-plus me-2" /> Add New SEV Level
        </button>
      </div>
      <div
        style={{
          height: '4.5rem',
        }}
        className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
      >
        <button
          type="button"
          onClick={discardSEVHandler}
          className="btn btn-outline-brand adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Discard
        </button>
        <button
          type="submit"
          className="btn btn-brand ms-3 adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Save changes
        </button>
      </div>
    </form>
  );
};

export default withRouter(SEV);
